export enum BrandName {
    msnbc = 'msnbc',
    cnbc = 'cnbc',
}

export enum ActivationScreenEvents {
    mvpdSelection = 'mvpdSelection',
    activationScreen = 'clientlessActivationScreen',
    confirmationScreen = 'clientlessConfirmationScreen',
    mvpdSelected = 'mvpdSelected',
    adobePassLanding = 'adobePassLanding',
    passSignIn = 'passsignin',
}

export interface AppMeasurementResponse {
    trackingServer: string
    pageName: string
    contextData: Record<string, string | number>
    linkTrackEvents: string
    linkTrackVars: string
    events: string
    pev2: string
    t: () => void
    tl: (status: boolean, label: string, name: string) => void
}
